import { useEffect, useState } from 'react';

export const ROTATION_INTERVAL_MS = 3000;

type Args = {
  messages: string[];
  active: boolean;
};

/**
 * Cycles through `messages` while `active`, one every {@link ROTATION_INTERVAL_MS}.
 * Restarts from the first message whenever it becomes active again.
 */
const useRotatingMessage = ({ messages, active }: Args) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (!active || messages.length < 2) {
      setIndex(0);
      return;
    }
    const interval = setInterval(
      () => setIndex((prev) => (prev + 1) % messages.length),
      ROTATION_INTERVAL_MS,
    );
    return () => clearInterval(interval);
  }, [active, messages.length]);

  return messages[index];
};

export default useRotatingMessage;
